<template>
  <div class="abnormal-order-drawer">
    <el-drawer
      title="异常订单"
      class="abnormal"
      :visible.sync="abnormalDrawer"
      :wrapperClosable="false"
      :before-close="handleCloseAbnormalDrawer">
        <el-tabs v-model="abnormalActiveName" @tab-click="handleAbnormalOrderDrawerTabsClick">
          <el-tab-pane label="未维护映射关系预警" name="mapping">
            <div class="table">
              <div class="title-container">
                <div class="title-abnormal-search">
                  <el-input v-model="abnormalCustomerName" placeholder="请输入货主名称" />
                  <el-button icon="el-icon-search" class="btn-blue" @click="searchAbnormal">搜索</el-button>
                </div>
                <el-button type="text" class="btn-text" icon="el-icon-refresh" @click="reimport"
                  >重新导入</el-button
                >
              </div>
              <el-table ref="table" :data="tableData" style="width: 100%">
                <el-table-column
                  v-for="(item, index) in tableTitleList"
                  :key="index"
                  :prop="item.prop"
                  :label="item.label"
                  show-overflow-tooltip
                  :min-width="item.width"
                ></el-table-column>
              </el-table>
            </div>
          </el-tab-pane>
          <el-tab-pane label="未维护商品重量预警" name="commodityWeightAlertNotMaintained">
            <div class="table">
              <div class="title-container">
                <div class="title-abnormal-search">
                  <el-input v-model="abnormalCommodityWeightAlertNotMaintainedCustomerName" placeholder="请输入货主名称" />
                  <el-select
                    v-model="abnormalCommodityWeightAlertNotMaintainedWarehouseId"
                    placeholder="请选择仓库"
                    class="abnormal-warehouse"
                    clearable
                  >
                    <el-option
                      v-for="item in warehouseList"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    ></el-option>
                  </el-select>
                  <el-button icon="el-icon-search" class="btn-blue" @click="searchAbnormalCommodityWeightAlertNotMaintained">搜索</el-button>
                </div>
              </div>
              <el-table ref="table" :data="commodityWeightAlertNotMaintainedTableData" style="width: 100%">
                <el-table-column
                  v-for="(item, index) in commodityWeightAlertNotMaintainedTableTitleList"
                  :key="index"
                  :prop="item.prop"
                  :label="item.label"
                  show-overflow-tooltip
                  :min-width="item.width"
                ></el-table-column>
                <el-table-column
                  label="操作"
                  width="120"
                >
                  <template slot-scope="scope">
                    <el-button
                      v-if="!scope.row.isFixed"
                      class="btn-text"
                      type="text"
                      @click="maintained(scope.row.id)"
                    >完成维护</el-button>
                  </template>
                </el-table-column>
              </el-table>
              <div class="pagination">
                <pagination-tpl
                  :total="commodityWeightAlertNotMaintainedTotal"
                  :currentPage="commodityWeightAlertNotMaintainedCurrent"
                  :pageSize="commodityWeightAlertNotMaintainedPageSize"
                  @queryChange="commodityWeightAlertNotMaintainedQueryChange"
                ></pagination-tpl>
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
      <div class="drawer-footer">
        <el-button class="btn-gray" @click="handleCloseAbnormalDrawer">关闭</el-button>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import AbnormalOrder from "models/page-head/abnormal-order";
import PaginationTpl from "components/base/PaginationTpl";
export default {
  // abnormalDrawer：异常订单开关; warehouseList：仓库集合; abnormalParentActiveName: 异常订单Tab切换开关
  props: ['abnormalDrawer', 'warehouseList', 'abnormalParentActiveName'],
  components: {
    PaginationTpl
  },

  data() {
    return {
      // 异常订单Tab切换开关
      // mapping:未维护映射关系预警; commodityWeightAlertNotMaintained
      abnormalActiveName: this.abnormalParentActiveName,
      // 未维护映射关系预警---货主名称搜索
      abnormalCustomerName: '',
      // 未维护映射关系预警---列表集合
      tableData: [],
      tableTitleList: [
        {label: '序号', prop: 'sort', width: ''},
        {label: '错误原因', prop: 'reason', width: '220'},
        {label: '错误条数', prop: 'nums', width: ''},
        {label: '货主名称', prop: 'customerName', width: ''},
      ],

      // 未维护商品重量预警---仓库id搜索
      abnormalCommodityWeightAlertNotMaintainedWarehouseId: '',
      // 未维护商品重量预警---货主名称搜索
      abnormalCommodityWeightAlertNotMaintainedCustomerName: '',
      commodityWeightAlertNotMaintainedTotal: 0,
      commodityWeightAlertNotMaintainedCurrent: 1,
      commodityWeightAlertNotMaintainedPageSize: 20,
      // 未维护商品重量预警---列表集合
      commodityWeightAlertNotMaintainedTableData: [],
      commodityWeightAlertNotMaintainedTableTitleList: [
        {label: '序号', prop: 'sort', width: ''},
        {label: '仓库', prop: 'warehouseName', width: ''},
        {label: '未维护商品编码 ', prop: 'code', width: ''},
        {label: '货主名称', prop: 'customerName', width: ''},
      ],
    }
  },

  watch: {
    abnormalDrawer: {
      handler(newVal) {
        if (newVal) {
          this.initOrderErrRecordList()
          this.initCommodityWeightAlertNotMaintainedList()
        }
      }
    },
    abnormalParentActiveName: {
      handler() {
        this.abnormalActiveName = this.abnormalParentActiveName
      }
    }
  },

  created() {},

  methods: {
    /** 
     * @desc 未维护映射关系预警列表
    */
    initOrderErrRecordList() {
      let customerName = this.abnormalCustomerName
      AbnormalOrder.getOrderErrRecordList(customerName).then(res => {
        if (res.success) {
          let arr = [];
          res.result.map((value, index) => {
            let obj = {};
            obj.sort = index+1 < 10 ? `0${index+1}`: index+1;
            obj.nums = value.failureCount;
            obj.customerName = value.customerName ;
            obj.reason = value.failureReason;
            arr.push(obj);
          });
          this.tableData = arr
        } else {
          this.$message.error(res.message);
        }
      })
    },

    /** 
     * @desc 未维护映射关系预警重新导入
    */
    reimport() {
      AbnormalOrder.postWmsReimport().then(res => {
        if (res.success) {
          this.$message.success('导入成功');
          this.initOrderErrRecordList()
        } else {
          this.$message.error(res.message);
        }
      })
    },

    /** 
     * @desc 搜索未维护映射关系预警列表
    */
    searchAbnormal() {
      this.initOrderErrRecordList()
    },



    /** 
     * @desc 未维护商品重量预警列表
    */
    initCommodityWeightAlertNotMaintainedList() {
      let customerName = this.abnormalCommodityWeightAlertNotMaintainedCustomerName
      let warehouseId = this.abnormalCommodityWeightAlertNotMaintainedWarehouseId
      let pageNo = this.commodityWeightAlertNotMaintainedCurrent
      AbnormalOrder.getCommodityWeightAlertNotMaintainedList(customerName, pageNo, warehouseId).then(res => {
        if (res.success) {
          this.commodityWeightAlertNotMaintainedPageSize = res.result.pageSize;
          this.commodityWeightAlertNotMaintainedTotal = res.result.totalNum;
          let arr = [];
          res.result.items.map((value, index) => {
            let obj = {};
            obj.id = value.id
            obj.sort = index+1 < 10 ? `0${index+1}`: index+1;
            obj.code = value.skuInfo;
            obj.warehouseName = value.warehouseName;
            obj.customerName = value.goodsOwner;
            obj.isFixed = value.isFixed;
            arr.push(obj);
          });
          this.commodityWeightAlertNotMaintainedTableData = arr
        } else {
          this.$message.error(res.message);
        }
      })
    },

    /** 
     * @desc 未维护商品重量预警列表---搜索
    */
    searchAbnormalCommodityWeightAlertNotMaintained() {
      this.commodityWeightAlertNotMaintainedCurrent = 1
      this.initCommodityWeightAlertNotMaintainedList()
    },

    /** 
     * @desc 未维护商品重量预警列表---翻页
    */
    commodityWeightAlertNotMaintainedQueryChange(data) {
      this.commodityWeightAlertNotMaintainedCurrent = data.currentPage;
      this.initCommodityWeightAlertNotMaintainedList();
    },

    /** 
     * @desc 未维护商品重量预警列表---完成维护
    */
    maintained(id) {
      let data = {
        id
      }
      AbnormalOrder.postMaintained(data).then(res => {
        if (res.success) {
          this.initCommodityWeightAlertNotMaintainedList()
        } else {
          this.$message.error(res.message);
        }
      })
    },

    /** 
     * @desc 关闭异常订单
    */
    handleCloseAbnormalDrawer() {
      this.abnormalCustomerName = ''
      this.abnormalCommodityWeightAlertNotMaintainedCustomerName = ''
      this.abnormalCommodityWeightAlertNotMaintainedWarehouseId = ''
      this.$emit('closeParentAbnormalDrawer')
    },

    /** 
     * @desc 获取异常订单当前tabs的名称
    */
    handleAbnormalOrderDrawerTabsClick(tab) {
      this.$emit('handleParentAbnormalOrderDrawerTabsClick', tab.name)
    }
  }
}
</script>

<style lang='scss'>

</style>
